<template>
    <ul class="doctor-list">
        <li class="doctor-list__item" v-for="doctor in doctorList" :key="doctor">
            <div class="doctor-list--img" v-if="doctor.mainDeptCd == 'HIMG'">
                <img :src="`https://mokdong.eumc.ac.kr/upload/doctor/info/${doctor.idImg}`" alt="">
            </div>
            <div class="doctor-list--img" v-else-if="doctor.img === 'lha'">
              <!--   김현우 이현아 이미지             -->
              <img src="/resource/img/lee-hyun-ah.png" alt="" style="transform: scale(1.4); transform-origin: center center;">
            </div>
            <div class="doctor-list--img" v-else-if="doctor.attachBag">
                <img :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor.attachBag.thumbs" onerror="this.style.display='none'">
            </div>
            <div class="doctor-list--img" v-else-if="doctor.imageSrc">
                <img :src="getImg(doctor)" alt="이미지" @error="this.style.display='none'">
            </div>
            <div class="doctor-list--img" v-else>
                <!--   김현우 이미지 없는곳             -->
            </div>
            <div class="doctor-list--con">
                <div class="doctor-list--text">
                    <template v-if="doctor.img ==='lha'">
                        <div class="doctor-list--name-wrap">
                            <h3 class="doctor-list--name">Lee Hyun-ah, руководитель медсестёр</h3>
                            <span class="title03 font-sub">Директор учебного центра медсестёр Эдмондса</span>
                        </div>
                        <p class="doctor-list--department">Специальная медсестринская команда отделения сестринского дела</p>
                    </template>

                    <template v-else>
                        <h3 class="doctor-list--name">{{doctor.drNameGlb}} профессор</h3>
                        <p class="doctor-list--department">{{doctor.belongGlb}}</p>

                        <h4 class="doctor-list--clinic">Специализированная медицинская</h4>
                        <p class="doctor-list--desc">{{doctor.detailField}}</p>
                    </template>
                </div>
                <div class="doctor-list--button" v-if="checkStaticData(doctor)">
                    <a :href="`https://seoul.eumc.ac.kr/eng/doctor/basicInfo.do?dr_sid=${doctor.drSid}&dept_cd=HIMG`" target="_blank" v-if="doctor.mainDeptCd == 'HIMG'">Информация</a>
                    <a :href="`/${$store.getters.getLang}/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`" target="_blank" v-else>Информация</a>
                </div>
            </div>
        </li>
    </ul>
</template>
<script>
export default{
    props: {
        doctorList: '',
    },
    methods: {
        getImg(doctor){
            if(!doctor.imageSrc){
                return false
            }
            try{
                return require(`@/assets/resource/img/${doctor.imageSrc}`)
            }catch(err){
                return require(`@/assets/resource/img/doctor_bg.png`)
            }
        },
        favoInfo(info){
            const obj = {}
            obj.favoYn = info.favoYn == 'Y' ? 'Y' : 'N'
            obj.no = info.drSid
            obj.type = 'DOCTOR'
            obj.doctorDetail = false
            return obj
        },
        normalReservation(doctor){
            this.getDoctorReserveDate(doctor, 'N')
        },
        quickReservation(doctor){
            this.getDoctorReserveDate(doctor, 'Q')
        },
        checkStaticData(doctor){
            return doctor.img !== 'lha' && doctor.img !== 'none' && doctor.imageSrc == null
        },
        getDoctorReserveDate(doctor, type){
            this.axios.get(this.api.doctor.getDate, {
                params: {
                    drSid: doctor.drSid
                }
            })
            .then(res => {
                const data = res.data
                if(data.code == 'OK'){
                    if(type == 'N'){
                        this.$store.state.reserveStore.normalReserve = doctor
                    }
                    if(type == 'Q'){
                        this.$store.state.reserveStore.quickReserve = doctor
                    }
                    this.$store.state.patInfoStore = {}
                    this.$router.push('/kr/reserve/reservation')
                }else{
                    alert(data.result)
                    if(data.code == 'not login'){
                        this.$router.push('/kr/login')
                    }
                }
            })
        }
    },
}
</script>